import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

class CaptionHeader extends React.PureComponent {
  getIcon = () => {
    let icon = '';

    switch (this.props.subtitleIcon) {
      case 'masks':
        icon = '/img/theatre-masks.svg';
        break;
      default:
        icon = '';
        break;
    }

    return (
      <img
        alt="Icon"
        width="20px"
        className="pr-10"
        src={icon}
      />
    );
  };

  renderTitle = () => {
    if (this.props.titleUrl) {
      return (
        <Link to={this.props.titleUrl}>
          {this.props.title}
        </Link>
      );
    }
    return this.props.title;
  };

  renderSubtitle = () => {
    if (this.props.subtitleUrl && this.props.subtitle) {
      return (
        <h3 className="location theater-title-production-grid-item">
          <Link to={this.props.subtitleUrl}>
            {this.props.subtitleIcon && this.getIcon()}
            {this.props.subtitle}
          </Link>
        </h3>
      );
    } else if (this.props.subtitle) {
      return (
        <h3 className="location theater-title-production-grid-item">
          {this.props.subtitleIcon && this.getIcon()}
          {this.props.subtitle}
        </h3>
      );
    }
    return (<span />);
  };

  render() {
    return (
      <header className={`clearfix ${this.props.noBorder && 'no-border'}`}>
        <div className="pull-left">
          <h1 className="title">
            {this.renderTitle()}
          </h1>
          {this.renderSubtitle()}
          {this.props.children}
        </div>
      </header>
    );
  }
}

CaptionHeader.propTypes = {
  noBorder: PropTypes.bool,
  title: PropTypes.string,
  titleUrl: PropTypes.string,
  subtitle: PropTypes.string,
  subtitleUrl: PropTypes.string,
  subtitleIcon: PropTypes.string,
  children: PropTypes.element,
};

CaptionHeader.defaultProps = {
  noBorder: false,
  title: '',
  titleUrl: undefined,
  subtitle: '',
  subtitleUrl: undefined,
  subtitleIcon: undefined,
  children: undefined,
};

export default CaptionHeader;



// WEBPACK FOOTER //
// ./src/components/Caption/CaptionHeader.js